export const environment = {
  production: false,
  name: 'staging',

  apiUrl: '',
  socketUrl: '',
  tenantId: 'treves-v3dut',

  firebase: {
    apiKey: 'AIzaSyCDf1EdCj7sevm4-jQB13StpRD6sUO6ssg',
    authDomain: 'yoshu-authentification-staging.firebaseapp.com',
    projectId: 'yoshu-authentification-staging',
    storageBucket: 'yoshu-authentification-staging.firebasestorage.app',
    messagingSenderId: '975978410660',
    appId: '1:975978410660:web:71d27eb6d8ef2f40772c31',
    measurementId: 'G-CTJF15NYNP'
  },

  features: {
    'module.admin': true,
    'module.admin.analytics': true,
    'module.admin.datasets': true,
    'module.admin.protocols': true,
    'module.admin.sites': true,
    'bot-response.avatar': 'yoshu_v2',
    'free-chat.hide-debug-traces': true,
    'free-chat.katex': true
  }
}
